import { format, toZonedTime } from 'date-fns-tz';

interface FormatDateTimeOptions {
  withTime?: boolean;
}

/**
 * Formats a date/time using system settings (timezone, dateFormat, timeFormat, language).
 * @param date Date object or string
 * @param settings Settings object from context
 * @param options Optional: withTime to include time
 */
export function formatDateTime(
  date: Date | string | number,
  settings: any,
  options: FormatDateTimeOptions = {}
): string {
  if (!date) return '';
  try {
    const tz = settings?.system?.timezone || 'Asia/Dhaka';
    const dateFormat = settings?.system?.dateFormat || 'dd/MM/yyyy';
    const timeFormat = settings?.system?.timeFormat || 'HH:mm';
    const language = settings?.system?.language || 'en';
    const zonedDate = toZonedTime(new Date(date), tz);
    let fmt = dateFormat;
    if (options.withTime) fmt += ` ${timeFormat}`;
    return format(zonedDate, fmt, { timeZone: tz, locale: undefined }); // Optionally add locale
  } catch {
    return '';
  }
} 